export const workstationFields = [
    { name: "workstationId", label: "Workstation ID", type: "text", readonly: true },

    {
        name: "workstationType",
        label: "Workstation Type",
        type: "select",
        option: ["Packing Station", "Return Station"],
        required: true
    },

    {
        name: "workstationLocation",
        label: "Workstation Location",
        type: "text",
        required: true
    },

    { name: "cameraIps", label: "Camera(s) IP (comma separated)", type: "text" },
    { name: "printerIps", label: "Printer(s) IP (comma separated)", type: "text" },
    { name: "marketplaceOrders", label: "Marketplace Orders (comma separated)", type: "text" },
    { name: "excludedCommodity", label: "Excluded Commodity", type: "text" },

    { name: "createdBy", label: "Created By", type: "text", readonly: true },
    { name: "createdDate", label: "Created Date", type: "text", readonly: true },
    { name: "updatedBy", label: "Updated By", type: "text", readonly: true },
    { name: "updatedDate", label: "Updated Date", type: "text", readonly: true }
];